var map = {
	"./2026-03-11.jpg": 9847,
	"./2026-03-29.png": 2460,
	"./2026-06-01.jpg": 9111,
	"./2026-07-10.jpg": 6124,
	"./2026-08-28.jpg": 2512,
	"./2026-09-13.jpg": 2608,
	"./2026-09-19.jpg": 9881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2219;